const GPS_REQUIREMENTS = {
  MAX_ACCURACY: 500,
  TIMEOUT: 10000,
};

export function getLocationStrict() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Геолокация не поддерживается"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude, accuracy } = pos.coords;

        if (accuracy > GPS_REQUIREMENTS.MAX_ACCURACY) {
          reject(new Error("Плохая точность геолокации"));
          return;
        }

        resolve({ latitude, longitude, accuracy });
      },
      (err) => {
        if (err.code === err.PERMISSION_DENIED) {
          reject(new Error("Геолокация запрещена"));
        } else if (err.code === err.TIMEOUT) {
          reject(new Error("Таймаут геолокации"));
        } else {
          reject(new Error("Ошибка геолокации"));
        }
      },
      {
        enableHighAccuracy: true,
        timeout: GPS_REQUIREMENTS.TIMEOUT,
        maximumAge: 0,
      },
    );
  });
}
